import { WorkspaceBinding } from "../../api/v2/types";

export interface BindingConflictLike {
  reason: string;
  index?: number;
  key?: string;
  value?: string;
}

export const mapConflictsByPath = (
  bindings: WorkspaceBinding[],
  conflicts: BindingConflictLike[]
): Record<string, string[]> => {
  const map: Record<string, string[]> = {};
  conflicts.forEach((conflict) => {
    if (typeof conflict.index === "number" && conflict.index >= 0) {
      const path = bindings[conflict.index]?.filePath;
      if (!path) return;
      map[path] = [...(map[path] || []), conflict.reason];
    }
  });
  return map;
};

export const conflictLabel = (reason: string) => {
  if (reason === "INVALID_LANGUAGE") return "Language is not in catalog";
  if (reason === "UNKNOWN_GROUP") return "Group does not exist";
  if (reason === "INVALID_FILE_EXTENSION") return "Only .json files are allowed";
  if (reason === "DUPLICATE_GROUP_LANGUAGE") return "Duplicate group+language pair";
  return reason;
};
